export function crmSync(fields) {
    $.post({
        type: "POST",
        url: "/home/accessory/crm_sync.php",
        data: {
            fields: fields
        }
    });
}